import {initTopPanelSearchInSuggestOracle, initTopPanelSearchSuggestOracle} from "../widgets/TopPanelSearchSuggestOracle"
import * as kendoThemeChooser from "./KednoThemeChooser";
import {ajaxJSON, isNullOrUndefined, noMenu} from "../common/NamaCommon";
import * as urls from "../constants/NamaURLS";
import {currentUserEmployeeId, currentUserId} from "../login/LoginPresenter";
import * as notifier from "../common/ErrorsNotification";
import * as ts from "../common/Translator";
import {isArabic, translateId} from "../common/Translator";
import NavBarTemplate from "../compiled-templates/NavBarTemplate";
import {downloadURL} from "../common/AttachmentLinkUtil";
import * as app from '../views/mainapp'
import {NamaKendoWindow} from '../views/NamaKendoWindow'
import {QuestionFieldsEditor} from "../widgets/QuestionFieldsEditor";
import * as DomainBaseEntities from "../constants/DomainBaseEntities";
import * as FieldType from "../constants/FieldType";
import {questionFiled} from "./edit/EditScreenMoreMenu";
import {changeLocale_, logout} from "../login/Security";
import * as cookies from "js-cookie";
import {backToOldGui, genQRCodeForUserInfo} from "../common/GUIUtilities";
import {dropDownFiltering} from "../widgets/DropDownListWidget";
import {NaMaAboutDialog} from "./NaMaAboutDialog";
import {applicationVersion} from "../common/DefaultApplicationInfo";
import {NamaRouterInstance} from "../routing/NamaRouter";
import * as places from "../routing/places";
import {update} from "../widgets/ApprovalsAndNotifications";
import {getCustomGUISettings} from "../login/ClientCache";

export function render() {
    return $(NavBarTemplate({
        translateId: ts.translateId,
        appVersion: applicationVersion(),
        smLogoImg: window.branding === 'exceed' ? "images/exceed-erp-logo-small1.png" :
            window.branding === 'capital' ? "images/capital-erp-logo-small1.svg" :
                window.branding === 'softvision' ? "images/softvision-logo-small1.svg" :
                    "images/nama-erp-logo-small1.png"
    }))
}

export function timedQueryChanged(result) {
    let event = new CustomEvent('timeQueryEvent', {detail: result});
    document.dispatchEvent(event);
}


function attachEventToTimeQueryLabel(element) {
    document.addEventListener("timeQueryEvent", function (event) {
        $(element).html(event.detail);
    });
}

let aboutDialog;

function attachEventToApplicationInfoBtn(element) {
    element.on("click", (e) => {
        e.preventDefault();
        if (!aboutDialog)
            aboutDialog = new NaMaAboutDialog();
        aboutDialog.show();
    });
}

function initCompanyNameIfNeeded(element) {
    let showCompanyNameNextToLogo = getCustomGUISettings().showCompanyNameNextToLogo;
    let companyName = window.companyName;
    if (isNullOrUndefined(showCompanyNameNextToLogo) || !showCompanyNameNextToLogo || !companyName)
        return;
    element.empty();
    element.text(companyName);
}

export function afterAttach() {
    let navbar = $("#nama-erp-header");
    handMenuToggleBtn(navbar);
    initNavbarDropdown(navbar);
    initTopPanelSearchSuggestOracle(navbar.find("#headerSearch"));
    initTopPanelSearchInSuggestOracle(navbar.find("#headerSearchIn"));
    initNavbarApprovalAndNotificationButtons(navbar);
    initLogoutBtn(navbar.find("#LogoutBtn"));
    initChangePasswordBtn(navbar.find("#changePassword"));
    initLangBtn(navbar.find("#lang_btn"));
    initBackToOldGui(navbar.find("#backToOldGui"));
    attachUserImageToBar(navbar.find("#userImg1"));
    attachUserImageToBar(navbar.find("#userImg2"));
    attachEventToTimeQueryLabel(navbar.find("#TimedQuery"));
    initCompanyNameIfNeeded(navbar.find("#applicationInfo"));
    attachEventToApplicationInfoBtn(navbar.find("#applicationInfo"));
    initGenQRCode(navbar.find("#genQRCode"));
    initHomePage(navbar.find("#homePage"));
    initMarkAsReadBtn(navbar.find("#markAsRead"));
}

function initMarkAsReadBtn(markAsRead) {
    markAsRead.kendoButton({
        icon: "checkmark",
        click: (e) => {
            e.preventDefault();
            ajaxJSON(urls.MarkAsReadTop5Notifications, {
                    employeeId: currentUserEmployeeId(),
                    userId: currentUserId()
                }, () => {
                    setTimeout(() => update(), 1);
                }
            );
        }
    });
}

function initHomePage(homePage) {
    homePage.click(function (e) {
        e.preventDefault();
        NamaRouterInstance.goTo(new places.WelcomePlace());
    });
}

function initGenQRCode(genQRCode) {
    genQRCode.click(function (e) {
        e.preventDefault();
        genQRCodeForUserInfo();
    });
}

function initBackToOldGui(backToOld) {
    let icon = backToOld.find("i");
    backToOld.on("mouseover", (e) => {
        icon.removeClass("fa-smile-o");
        icon.addClass("fa-frown-o");
    });
    backToOld.on("mouseout", (e) => {
        icon.removeClass("fa-frown-o");
        icon.addClass("fa-smile-o");
    });
    backToOld.click(function (e) {
        e.preventDefault();
        backToOldGui();
    });
}

function attachUserImageToBar(element) {
    let fileId = app.instance.loginInfo.userInfo.mainFile.attachmentInfo.fileId;
    let imgSrc = downloadURL(fileId, "User", "THUMBNAIL", false) + "&userImage=true";
    element.attr("src", imgSrc);
}

function initLangBtn(langBtn) {
    langBtn.click(function (e) {
        changeLocale_();
    });
}

function initChangePasswordBtn(btn) {
    btn.kendoButton({
            click: function (e) {
                createAndShowPopup();
            }
        }
    );
}

export function findQuestionFieldVal(filledQuestionFields, fieldId) {
    for (let question of filledQuestionFields) {
        if (question.id === fieldId)
            return question.value;
    }
    return null;
}

export function findQuestionObjFieldVal(filledQuestionFields, fieldId) {
    for (let question of filledQuestionFields) {
        if (question.id === fieldId)
            return question.objValue;
    }
    return null;
}

function createAndShowPopup() {
    let questionFieldsEditor = new QuestionFieldsEditor(DomainBaseEntities.User);
    /**
     *
     * @type {namaTypes.NamaWindowBtnData}
     */
    let okBtnData = {
        btnTitle: "ok", btnAction: () => {
            let filledQuestionFields = questionFieldsEditor.getQuestionFields();
            let userImgAttachmentInfo = findQuestionObjFieldVal(filledQuestionFields, "userImage") ? findQuestionObjFieldVal(filledQuestionFields, "userImage").attachmentInfo : {};
            let changePasswordInfo =
                {
                    userIdToChangePasswordFor: currentUserId(),
                    newPassword: findQuestionFieldVal(filledQuestionFields, "password"),
                    confirmPassword: findQuestionFieldVal(filledQuestionFields, "confirmNewPassword"),
                    userEmail: findQuestionFieldVal(filledQuestionFields, "userEmail"),
                    emailPassword: findQuestionFieldVal(filledQuestionFields, "emailPassword"),
                    imageName: userImgAttachmentInfo.fileName,
                    passwordMustBeChanged: false
                };
            ajaxJSON(urls.Change_Password, {
                    changePasswordInfo: JSON.stringify(changePasswordInfo),
                    userImageFileId: userImgAttachmentInfo.fileId
                }, () => {
                    changePasswordWindow.closeWindow();
                    notifier.showSuccess(translateId("operationSuccessfull"));
                    app.instance.loginPresenter.initLoginModal();
                }
            );
        }
    };
    /**
     *
     * @type {namaTypes.NamaWindowBtnData}
     */
    let cancelBtnData = {
        btnTitle: "cancel"
    };
    let changePasswordWindow = new NamaKendoWindow("Change Password", okBtnData, cancelBtnData);
    let questionFields = [];
    questionFields.push(questionFiled("currentPassword", null, FieldType.Password));
    questionFields.push(questionFiled("password", null, FieldType.Password));
    questionFields.push(questionFiled("confirmNewPassword", null, FieldType.Password));
    questionFields.push(questionFiled("userEmail", null, FieldType.Text));
    questionFields.push(questionFiled("emailPassword", null, FieldType.Password));
    questionFields.push(questionFiled("userImage", null, FieldType.Binary));
    questionFieldsEditor.edit(questionFields, null, null, null, null, changePasswordWindow);
    changePasswordWindow.showWindow();
}

function initNavbarApprovalAndNotificationButtons(navbar) {
    navbar.find("#topheadermenu").kendoMenu();
}

function initLogoutBtn(logoutBtn) {
    logoutBtn.kendoButton({
        click: (e) => (
            logout())
    })
}

function handMenuToggleBtn(navbar) {
    if(noMenu())
        return ;
    let menu = $("#menu");
    let API = menu.data("mmenu");
    if (!API) {
        setTimeout(() => handMenuToggleBtn(navbar), 1000);
        return;
    }
    let showHideBtnKlass = isArabic() ? "fa-chevron-left" : "fa-chevron-right";
    navbar.find("#butShowHide").find("i").addClass(showHideBtnKlass);
    navbar.find("#butShowHide").click(() => {
        if (!menu.attr("toggleButtonClickHandled")) {
            menu.attr("toggleButtonClickHandled", "true");
            API.bind('open:start', () => {
                changeShowHideBtn($("#butShowHide").find("i"));
            });
            API.bind('close:finish', () => {
                changeShowHideBtn($("#butShowHide").find("i"));
            });
        }
        if (menu.hasClass("mm-opened"))
            API.close();
        else
            API.open();
    });
}

function changeShowHideBtn(element) {
    let leftKlass = "fa-chevron-left";
    let rightKlass = "fa-chevron-right";
    if (element.hasClass(leftKlass)) {
        element.removeClass(leftKlass);
        element.addClass(rightKlass);
        return;
    }
    if (element.hasClass(rightKlass)) {
        element.removeClass(rightKlass);
        element.addClass(leftKlass);

    }

}

function initNavbarDropdown(navbar) {
    let themes = navbar.find("#theme");
    let fonts = navbar.find("#font-size");
    let fontType = navbar.find("#font-type");
    let template = kendo.template(`<span class="tc-color" style="background-color: #: color1 #"></span>
<span class="tc-color" style="background-color: #: color2 #"></span>
<span class="tc-color" style="background-color: #: color3 #"></span>
    <span>#: text #</span>`);
    let data = [
        {text: "Black", value: "black", color1: "#0167cc", color2: "#4698e9", color3: "#272727"},
        {text: "Blue Opal", value: "blueopal", color1: "#076186", color2: "#7ed3f6", color3: "#94c0d2"},
        {text: "Default", value: "default", color1: "#ef6f1c", color2: "#e24b17", color3: "#5a4b43"},
        {text: "Fiori", value: "fiori", color1: "#007cc0", color2: "#e6f2f9", color3: "#f0f0f0"},
        {text: "Flat", value: "flat", color1: "#363940", color2: "#2eb3a6", color3: "#fff"},
        {text: "High Contrast", value: "highcontrast", color1: "#b11e9c", color2: "#880275", color3: "#1b141a"},
        {text: "Material", value: "material", color1: "#3f51b5", color2: "#283593", color3: "#fff"},
        {text: "Metro Black", value: "metroblack", color1: "#00aba9", color2: "#0e0e0e", color3: "#565656"},
        {text: "Moonlight", value: "moonlight", color1: "#ee9f05", color2: "#40444f", color3: "#212a33"},
        {text: "Metro", value: "metro", color1: "#8ebc00", color2: "#787878", color3: "#fff"},
        {text: "Nova", value: "nova", color1: "#ff4350", color2: "#00acc1", color3: "#303553"},
        {text: "Office 365", value: "office365", color1: "#0072c6", color2: "#cde6f7", color3: "#fff"},
        {text: "Silver", value: "silver", color1: "#298bc8", color2: "#515967", color3: "#eaeaec"},
        {text: "Uniform", value: "uniform", color1: "#666", color2: "#ccc", color3: "#fff"},
        {text: "Material Black", value: "materialblack", color1: "#3f51b5", color2: "#1c1c1c", color3: "#4d4d4d"},
    ];
    for (let d of data) {
        d.searchData = d.value.toUpperCase() + " " + d.value.toLowerCase();
    }
    themes.kendoDropDownList({
        dataTextField: "text",
        dataValueField: "value",
        value: kendoThemeChooser.currentTheme(),
        filter: "contains",
        dataSource: data,
        valueTemplate: template,
        template: template,
        filtering: function (ev) {
            dropDownFiltering(ev, this.dataSource);
        },
        change: function (e) {
            let theme = this.value();
            localStorage.setItem("nama-k-theme", theme);
            cookies.set("namatheme", theme, {expires: 1000});
            location.reload();
        }
    });

    function changeFontSize(e) {
        let value = fonts.kendoDropDownList("value");
        kendoThemeChooser.changeFontSize(value);
    }

    function changeFontType(e) {
        let value = fontType.kendoDropDownList("value");
        kendoThemeChooser.changeFontType(value);
    }

    fonts.kendoDropDownList({
        dataTextField: "text",
        dataValueField: "value",
        filter:"contains",
        value: kendoThemeChooser.currentFontSize(),
        height: 204,
        dataSource: [
            {text: "8px", value: 8},
            {text: "9px", value: 9},
            {text: "10px", value: 10},
            {text: "11px", value: 11},
            {text: "12px", value: 12},
            {text: "13px", value: 13},
            {text: "14px", value: 14},
            {text: "15px", value: 15},
            {text: "16px", value: 16},
            {text: "17px", value: 17},
            {text: "18px", value: 18},
            {text: "19px", value: 19},
            {text: "20px", value: 20},
            {text: "21px", value: 21},
            {text: "22px", value: 22},
            {text: "23px", value: 23},
            {text: "24px", value: 24},
            {text: "25px", value: 25}
        ],
        change: changeFontSize
    });

    fontType.kendoDropDownList({
        filter: "contains",
        value: kendoThemeChooser.currentFontType(),
        height: 204,
        dataSource: ['Times New Roman', 'serif', 'Arial', 'georgia', 'fantasy', 'monospace', 'helvetica', 'cursive', 'tahoma', 'lato', 'Verdana'
            , 'Amiri', 'Droid Arabic Kufi', 'Droid Arabic Naskh', 'Lateef', 'Scheherazade', 'Thabit'],
        change: changeFontType
    });

    navbar.find("#theme-list, #dimensions-list, #font-size, #font-type").addClass("ra-list");

    navbar.find("#configurator-wrap").kendoResponsivePanel({
        breakpoint: 1200,
        orientation: "top"
    });
}